<template>
  <div class="similar-news" :class="{ background: background }">
    <div class="similar-news__content container">
      <div class="top flex al-center between">
        <div class="similar-news__title font-23 bold uppercase">
          {{ _.get(contentData, "conf.header.title") }}
        </div>
        <a
          v-if="_.get(contentData, `conf.header.full_list_url`)"
          :href="_.get(contentData, `conf.header.full_list_url`)"
          class="view-all uppercase pointer"
        >
          {{ _.get(contentData, "conf.header.full_list_title") }}

          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="7.857"
            height="10"
            viewBox="0 0 7.857 10"
          >
            <path
              id="Icon_material-play-arrow"
              data-name="Icon material-play-arrow"
              d="M12,7.5v10l7.857-5Z"
              transform="translate(-12 -7.5)"
              fill="#4d4d4f"
            />
          </svg>
        </a>
      </div>

      <swiper ref="slider" class="similar-news-slider" :options="swiperOptions">
        <swiper-slide
          class="single-slide"
          v-for="(item, index) in _.get(contentData, 'data.list')"
          :key="index"
        >
          <NewsCard :data="item" />
        </swiper-slide>
      </swiper>
      <div class="swiper-navigation-button white swiper-prev swiper-prev-news">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="7.857"
          height="10"
          viewBox="0 0 7.857 10"
        >
          <path
            id="Icon_material-play-arrow"
            data-name="Icon material-play-arrow"
            d="M12,7.5v10l7.857-5Z"
            transform="translate(-12 -7.5)"
            fill="#fff"
          />
        </svg>
      </div>

      <div class="swiper-navigation-button white swiper-next swiper-next-news">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="7.857"
          height="10"
          viewBox="0 0 7.857 10"
        >
          <path
            id="Icon_material-play-arrow"
            data-name="Icon material-play-arrow"
            d="M12,7.5v10l7.857-5Z"
            transform="translate(-12 -7.5)"
            fill="#fff"
          />
        </svg>
      </div>
      <a
        v-if="_.get(contentData, `conf.header.full_list_url`)"
        :href="_.get(contentData, `conf.header.full_list_url`)"
        class="view-all uppercase pointer mobile"
      >
        {{ _.get(contentData, "conf.header.full_list_title") }}

        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="7.857"
          height="10"
          viewBox="0 0 7.857 10"
        >
          <path
            id="Icon_material-play-arrow"
            data-name="Icon material-play-arrow"
            d="M12,7.5v10l7.857-5Z"
            transform="translate(-12 -7.5)"
            fill="#4d4d4f"
          />
        </svg>
      </a>
    </div>
  </div>
</template>

<script>
import NewsCard from "./NewsCard.vue";

export default {
  props: ["contentData"],

  components: {
    NewsCard
  },

  data() {
    return {
      background: true,
      swiperOptions: {
        speed: 800,
        slidesPerView: 3,
        spaceBetween: 30,
        watchOverflow: true,
        navigation: {
          nextEl: ".similar-news .swiper-next-news",
          prevEl: ".similar-news .swiper-prev-news"
        },
        breakpoints: {
          320: {
            slidesPerView: 1.4
          },
          500: {
            slidesPerView: 2.3
          },
          1024: {
            slidesPerView: 3
          }
        }
      }
    };
  }
};
</script>

<style lang="scss">
.similar-news {
  background: #f7f7f7;
  padding: 55px 0 89px;
  &.background {
    background: #fff;
  }
  @media (max-width: 1024px) {
    padding: 55px 0 160px;
  }
  &__content {
    position: relative;
  }
  .view-all {
    color: $black;
    @media (max-width: 767px) {
      display: none;
    }
  }
  .mobile {
    display: none;
    @media (max-width: 767px) {
      display: block;
      position: absolute;
      bottom: -70px;
      right: 15px;
    }
  }
  .swiper-navigation-button {
    top: calc(50% - 20px);
    @media (max-width: 767px) {
      &.white.swiper-prev {
        top: unset;
      }
      // &.white.swiper-next {
      //   right: 25px !important;
      //   left: unset;
      //   top: calc(50% - 20px);
      // }
    }
  }
  .top {
    padding-bottom: 55px;
  }
}
</style>
